export default __webpack_public_path__ + "static/media/platinum-icon.dbc05c6c.png";